import { useRef, useCallback, forwardRef, useImperativeHandle } from 'react';
import SearchZip from './SearchZip';
import { useGridCellEditor } from 'ag-grid-react';

const SearchEditor = forwardRef((props, ref) => {
  const inputRef = useRef(null);
  const valueRef = useRef(null);

  const isCancelBeforeStart = useCallback(() => {
    const { colDef } = props.column || {};
    return colDef && colDef.type === "isCancelBeforeStart";
  }, [props.column]);

  const isCancelAfterEnd = useCallback(() => {
    props.onValueChange?.(valueRef.current);
    return false;
  }, [props.onValueChange]);

  const focusInput = useCallback(() => {
    if (
      inputRef &&
      inputRef.current &&
      inputRef.current.select
    ) {
      inputRef.current.select.focus();
    }
  }, []);

  const clearValue = useCallback(() => {
    if (
      inputRef &&
      inputRef.current &&
      inputRef.current.select &&
      inputRef.current.select.select
    ) {
      inputRef.current.select.select.clearValue();
    }
  }, []);

  const afterGuiAttached = useCallback(() => {
    focusInput();
  }, [focusInput]);

  useGridCellEditor({
    isCancelBeforeStart,
    isCancelAfterEnd,
    afterGuiAttached,
    focusInput
  });

  useImperativeHandle(ref, () => ({
    focusInput,
    clearValue
  }));

  const handleUpdate = useCallback(
    (value) => {
      const finalValue = value === undefined ? null : value;
      valueRef.current = finalValue;
      props.onChange?.(finalValue);
    },
    [props.onChange]
  );

  return (
    <SearchZip
      value={
        props.formatValue
          ? props.formatValue() || props.value
          : props.value
      }
      onChange={handleUpdate}
      inputRef={inputRef}
      {...props}
    />
  );
});

SearchEditor.displayName = 'SearchEditor';

export default SearchEditor;

